<template>
    <div class="label__emit--wrap" :class="disabled ? 'disabled' : ''">
        <label class="label__emit--button gray">
            <span>Choisir</span>
            <input type="file" class="import-button" hidden enctype="multipart/form-data" @change="handleFileChange" :accept="allowedFileExtensions">
        </label>
        <div class="label__emit__block" :class="{'file-exist col-6': fileExist}">
            <span class="label__emit__block--placeholder" v-if="value">{{value.name}}</span>
            <span class="label__emit__block--placeholder" v-else-if="options.currentFile">{{options.currentFile.toLowerCase()}}</span>
            <span class="label__emit__block--placeholder" v-else>{{ options.name }}</span>
        </div>
        <div v-if="fileExist" class="portlet__head--button-group col-3">
            <button v-if="!isBusy" class="orange-button" :disabled="!validFileUpload"  @click="uploadDocument()">
                <span>Ajouter</span>
            </button>
            <button v-else class="orange-button" disabled="true">
                <span>Uploading</span>
            </button>
        </div>
    </div>
</template>

<script>
    import {required} from 'vuelidate/lib/validators';
    import {validationMixin} from 'vuelidate'

    export default {
        props: {
            value: File,
            options: Object,
            disabled: Boolean,
            apiUrl: {
                type: String,
                default: 'guarantees/import/list'
            },
            allowedFileExtensions: {
                type: String,
                default: 'application/vnd.ms-excel, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
            }
        },
        data() {
            return {
                file: null,
                type: '',
                isBusy: false
            }
        },
        mixins: [
            validationMixin
        ],
        methods: {
            handleFileChange(e) {
                let file = e.target.files[0];
                this.$emit('input', file);
                this.file = file;
                this.type = file.type;
            },
            uploadDocument() {
                if(!this.$v.file.$invalid) {
                    this.isBusy = true;
                    let defaultUrl = this.isDentalRepresentative ? 'dental/import' : 'guarantees/import/list';
                    let url = (this.apiUrl && this.apiUrl !== 'guarantees/import/list') ? this.apiUrl : defaultUrl;
                    let data = {
                        file: this.file,
                        type: this.type,
                    };

                    this.apiFile(url, data)
                        .then(response => {
                            this.showSuccessNotification('Les garanties ont été importées avec succès');
                            this.$emit('uploaded', response.data.info);
                            this.clearFields();
                            this.isBusy = false;
                        })
                        .catch(error => {
                            this.showErrorNotification(error);
                            this.isCommentSendBusy = false;
                        })
                } else {
                    this.showWarningNotification('Please fill all required fields')
                }
            },
            clearFields() {
                this.file = null;
                this.options.currentFile = false;
                this.options.hash = null;
                this.options.name = 'Choisir un document';
            },
        },
        computed: {
            fileExist() {
                return !!this.value || this.options.currentFile;
            },
            validFileUpload() {
                return !!this.file;
            },
            isDentalRepresentative() {
                let user = (this.$store && this.$store.state.userInfo && Object.keys(this.$store.state.userInfo).length > 0)
                  ? this.$store.state.userInfo
                  : null;

                if (!user) {
                  try {
                    user = JSON.parse(localStorage.getItem('user')) || {};
                  } catch (e) {
                    user = {};
                  }
                }

                const rep = user.representative || (this.$store && this.$store.getters.isRepresentative ? this.$store.getters.getRepresentative : null);
                const repId = rep ? rep.id : (user.representative_id || (user.mechanic ? user.mechanic.representative_id : null));
                const repName = rep && rep.name ? rep.name.toUpperCase() : '';

                return (
                  repId == 64 ||
                  repId == 65 ||
                  repName.includes('MEGA DENTAL') ||
                  repName.includes('HENRY SCHEIN') ||
                  repName.includes('DENTAL')
                );
            }
        },
        validations: {
            file: {
                required
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/Garantie/Import/ImportGuaranteesLoadFileInput.vue